module.exports = __webpack_public_path__ + "img/patrocinadores_chimex.84a35608.png";